const EXTENSIONS = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/gif': 'gif', 'image/avif': 'avif',
  'application/pdf': 'pdf', 'video/mp4': 'mp4', 'application/zip': 'zip', 'text/plain': 'txt' };
export function downloadName(file = {}, type = '', disposition = '') {
  let header = '';
  try { header = decodeURIComponent(disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1] || disposition.match(/filename="?([^";]+)/i)?.[1] || ''); } catch { /* use stored name */ }
  let pathName = '';
  try { pathName = decodeURIComponent(new URL(file.link || file.url || file.file || '', 'https://local.invalid').pathname.split('/').pop() || ''); } catch { /* use stored name */ }
  let name = String(header || file.original_name || file.name || pathName || 'Файл').split(/[\\/]/).pop().replace(/[<>:"|?*\u0000-\u001f]/g, '_').trim() || 'Файл';
  const ext = EXTENSIONS[type.toLowerCase().split(';')[0]] || pathName.match(/\.([a-z\d]{1,10})$/i)?.[1];
  if (!/\.[a-z\d]{1,10}$/i.test(name) && ext) name += `.${ext}`;
  return name;
}
export async function normalizedFileBlob(blob, file) {
  const prefix = new Uint8Array(await blob.slice(0, 16).arrayBuffer());
  const magic = prefix[0] === 0xff && prefix[1] === 0xd8 ? 'image/jpeg'
    : prefix[0] === 0x89 && prefix[1] === 0x50 && prefix[2] === 0x4e ? 'image/png'
    : String.fromCharCode(...prefix.slice(0,4)) === '%PDF' ? 'application/pdf' : null;
  let type = blob.type.toLowerCase().split(';')[0];
  if (magic) type = magic;
  if (!type || type === 'application/octet-stream') {
    const ext = downloadName(file).split('.').pop().toLowerCase();
    type = Object.entries(EXTENSIONS).find(([, value]) => value === ext || value === 'jpg' && ext === 'jpeg')?.[0] || 'application/octet-stream';
  }
  return type === blob.type ? blob : new Blob([blob], { type });
}
